<template>
    <div class="students_terms">
        <fluke-card>
            <header>
                <div class="title">Termo de Consentimento</div>
                <div class="description">
                    Lista de todos os alunos que assinaram o Termo de
                    Consentimento
                </div>
            </header>
            <main>
                <v-select
                    v-model="selected_filters"
                    :items="filters"
                    :menu-props="{ maxHeight: '400' }"
                    @change="filter"
                    label="Filtros"
                    multiple
                    hint="Selecione os cursos desejados"
                    persistent-hint
                >
                </v-select>

                <v-data-table
                    :headers="headers"
                    :items="students_terms"
                    :search="search"
                    :rows-per-page-items="[15, 30, 60]"
                    rows-per-page-text="Linhas pos página"
                    class="inner-tables"
                    disable-initial-sort
                >
                    <template v-slot:items="props">
                        <td>
                            {{ props.item.first_name }}
                            {{ props.item.last_name }}
                        </td>
                        <td>{{ props.item.email }}</td>
                        <td>{{ props.item.document_number }}</td>
                        <td>{{ props.item.phone }}</td>
                        <td>{{ props.item.foreigner_document }}</td>
                        <td>{{ props.item.course }}</td>
                        <td>{{ props.item.course_date }}</td>
                        <td>{{ props.item.ip }}</td>
                        <td class="text-xs-center">
                            {{ props.item.privacy_version }}
                        </td>
                        <td>{{ props.item.created_at }}</td>
                    </template>
                    <template v-slot:no-results>
                        <v-alert :value="true" color="error" icon="warning">
                            Sua busca por "{{ search }}" não achou nenhum
                            resultado.
                        </v-alert>
                    </template>
                </v-data-table>
                <div class="flexsplit">
                    <div class="searchtable">
                        <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Pesquise"
                            single-line
                            hide-details
                        >
                        </v-text-field>
                    </div>
                    <div></div>
                </div>
            </main>
            <footer>
                <fluke-button
                    v-if="permission.term_files.read"
                    @click.native="$router.push('term_files')"
                    >Gerenciar PDF Termos</fluke-button
                >
                <download-excel
                    class="fluke-btn export-btn"
                    :data="students_terms"
                    :fields="json_fields"
                    worksheet="Termo de Consentimento Worksheet"
                    name="termo-de-consentimento.xls"
                >
                    <i class="material-icons">get_app</i>
                    Download XLS
                </download-excel>
            </footer>
        </fluke-card>
    </div>
</template>

<script>
import axios from "axios";
import Card from "../../components/Main/Content/Card/Card.vue";
import Button from "../../components/Main/Content/Button/Button.vue";
import permission from "../../mixins/permissions";

export default {
    mixins: [permission],
    components: {
        "fluke-card": Card,
        "fluke-button": Button,
    },
    data: function () {
        return {
            students_terms: [],
            filters: [],
            selected_filters: [],
            search: "",
            headers: [
                {
                    text: "Nome",
                    align: "left",
                    value: "first_name",
                },
                {
                    text: "E-mail",
                    align: "left",
                    value: "email",
                },
                {
                    text: "CPF",
                    align: "left",
                    value: "document_number",
                },
                {
                    text: "Telefone",
                    align: "left",
                    value: "phone",
                },
                {
                    text: "Curso",
                    align: "left",
                    value: "course",
                },
                {
                    text: "Data do Curso",
                    align: "left",
                    value: "course_date",
                },
                {
                    text: "IP",
                    align: "left",
                    value: "ip",
                },
                {
                    text: "Data do Cadastro",
                    align: "left",
                    value: "orignal_created_at",
                },
            ],
            json_fields: {
                dbID: "id",
                Nome: "first_name",
                Sobrenome: "last_name",
                "E-mail": "email",
                CPF: "document_number",
                Telefone: "phone",
                Curso: "course",
                "Data do Curso": "course_date",
                IP: "ip",
                "Aceite Privacidade": "privacy_term_checked",
                "Aceite Uso Imagem/Video": "auth_term_checked",
                "Arquivo Privacidade": "privacy_term_file_name",
                "Arquivo Uso Imagem/Video": "auth_term_file_name",
                "Data do Cadastro": "created_at",
            },
            json_data: [],
            json_meta: [
                [
                    {
                        key: "charset",
                        value: "utf-8",
                    },
                ],
            ],
            permission: {
                students_terms: {
                    read: false,
                    write: false,
                },
                term_files: {
                    read: false,
                    write: false,
                },
            },
        };
    },
    created: function () {
        const defaultPermissions = { read: false, write: false };
        this.permission.students_terms =
            this.getUserPagePermission("students_terms");
        if (!this.permission.students_terms) {
            this.permission.students_terms = { ...defaultPermissions };
        }
        this.permission.term_files = this.getUserPagePermission("term_files");
        if (!this.permission.term_files) {
            this.permission.term_files = { ...defaultPermissions };
        }

        if (this.permission.students_terms.read == false) {
            this.$router.push("/");
        }
        this.get();
        this.getFilters();
    },
    formatData(elem) {
        const formatDate = (value, withHour = true) => {
            let newData = value.slice(0, -8).split("T");
            newData =
                newData[0].split("-").reverse().join("/") +
                (withHour ? " " + newData[1] : "");
            return newData;
        };
        const formatBool = (value) => (+value === 1 ? "V" : "F");
        elem.course_date = formatDate(elem.course_date, false);
        elem.orignal_created_at = elem.created_at;
        elem.created_at = formatDate(elem.created_at);
        elem.privacy_term_checked = formatBool(elem.privacy_term_checked);
        elem.auth_term_checked = formatBool(elem.auth_term_checked);
        return elem;
    },
};
</script>
